<template>
  <card-item card="item_guardian_cloud" :tabs="tabs" :activeTab="activeTab" :id="id"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
        {
          title: "Адреса",
          component: () => import("./Address"),
              key:'addresses',
        },
        {
          title: "",
          component: () => import("./GuardianClient"),
              key:'childrens',
        },
      ],
      activeTab: 0,
    };
  },
};
</script>